import script from "./Drafts.vue?vue&type=script&setup=true&lang=js"
export * from "./Drafts.vue?vue&type=script&setup=true&lang=js"

import "./Drafts.vue?vue&type=style&index=0&id=854ea8ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854ea8ea"]])

export default __exports__